import React, { FunctionComponent, useState, useCallback } from 'react';
import { Presentation } from './presentation';

type Props = {
  interest: 'want_to_work' | 'want_to_hear' | 'interesting';
  isConnectModalOpen: boolean;
  isConnectCompleteModalOpen: boolean;
  isLoggedIn: boolean;
  isPerson: boolean;
  isScouted: boolean;
  showMidCareerWarning: boolean;
  companyId: number;
  recruitmentId?: number;
  isSubmitting: boolean;
  handleSubmitConnect: (e: React.MouseEvent<HTMLButtonElement>) => void;
  handleChangeInterest: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Component: FunctionComponent<Props> = ({
  interest,
  isConnectModalOpen,
  isConnectCompleteModalOpen,
  isLoggedIn,
  isPerson,
  isScouted,
  showMidCareerWarning,
  companyId,
  recruitmentId,
  isSubmitting,
  handleSubmitConnect,
  handleChangeInterest,
}) => {
  return (
    <Presentation
      isConnectModalOpen={isConnectModalOpen}
      isConnectCompleteModalOpen={isConnectCompleteModalOpen}
      isLoggedIn={isLoggedIn}
      isPerson={isPerson}
      isScouted={isScouted}
      showMidCareerWarning={showMidCareerWarning}
      companyId={companyId}
      recruitmentId={recruitmentId}
      interest={interest}
      isSubmitting={isSubmitting}
      handleSubmitConnect={handleSubmitConnect}
      handleChangeInterest={handleChangeInterest}
    />
  );
};
